import { Button, Card, Divider, Flex, Space, Typography } from 'antd';
import React from 'react';

import {
  AssessmentStepPager,
  type AssessmentFlowStep,
} from '@/components/assessment/AssessmentStepPager';

/** Props for the `StepOutput` placeholder output view. */
export interface StepOutputProps {
  stepNumber: 1 | 2 | 3 | 4;
  onBackToStep: () => void;
  onContinue: () => void;
  onNavigateAssessmentStep?: (step: AssessmentFlowStep) => void;
}

const { Paragraph, Title } = Typography;

export const StepOutput: React.FC<StepOutputProps> = ({
  stepNumber,
  onBackToStep,
  onContinue,
  onNavigateAssessmentStep,
}) => {
  const reviewStep = `${stepNumber}-review` as AssessmentFlowStep;

  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Flex align="center" justify="space-between" gap={16} wrap="wrap">
          <Title level={4} style={{ margin: 0 }}>
            Step 0{stepNumber} Output
          </Title>
          {onNavigateAssessmentStep ? (
            <AssessmentStepPager current={reviewStep} onStepChange={onNavigateAssessmentStep} />
          ) : null}
        </Flex>
        <Paragraph>
          This mock output panel represents the generated artifact structure. Replace these blocks
          with mapped API content in the next integration phase.
        </Paragraph>
        <Divider />
        <Space>
          <Button onClick={onBackToStep}>Back to Step</Button>
          <Button type="primary" onClick={onContinue}>
            Continue
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export default StepOutput;
